import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { selectUserDetails } from '../store/slices/userSlice';
import TrackingService from '../services/TrackingService';

const usePageTracking = (pageName) => {
  const startTimeRef = useRef(Date.now());
  const userDetails = useSelector(selectUserDetails);

  console.log('userDetails ', userDetails);

  console.log(`[Tracking Debug] START: ${pageName} at ${startTimeRef.current}`);
  const pageUrl = window.location.pathname;

  useEffect(() => {
    // Log the initial view event dynamically
    // Use the provided name, but if it's missing or generic, derive it from the URL
    const dynamicName =
      !pageName || pageName === 'button_click' ? pageUrl.split('/').filter(Boolean).pop()?.replace(/-/g, ' ') || 'Home' : pageName;

    TrackingService.logEvent({
      page_name: dynamicName,
      page_url: pageUrl,
      event_type: 'view'
    });

    return () => {
      const endTime = Date.now();
      const timeSpentSeconds = Math.round((endTime - startTimeRef.current) / 1000);

      // Only log significant engagement (more than 2 seconds)
      if (timeSpentSeconds > 2) {
        TrackingService.logEvent({
          page_name: dynamicName,
          page_url: pageUrl,
          event_type: 'time_spent',
          time_spent_seconds: timeSpentSeconds
        });
      }
    };
  }, [pageName, pageUrl]);
};

export default usePageTracking;
